export default __webpack_public_path__ + "static/media/EL_logo-big.024a797f.svg";